import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router} from '@angular/router';
import {Injectable} from '@angular/core';



@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isLoggedIn = localStorage.getItem('isLoggedIn') || AuthGuard.readCookie('isLoggedIn');
    if (!isLoggedIn) this.router.navigateByUrl('/');
    return true;
  }

  static readCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
      let c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  static deleteCookieByName(name: string) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };


  static writeCookie(key, value) {
    document.cookie = `${key}=${value}; UTC; path=/`;
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/service/auth-guard.service.ts